module.exports = __webpack_public_path__ + "img/best-bot.7088a747.png";